import { InstrumentDetailDto, InstrumentEditDto } from './instrument';

export const mapInstrumentDetailToEdit = (
  dto: InstrumentDetailDto
): InstrumentEditDto => ({
  id: dto.id,
  name: dto.name,
  active: dto.active,
  description: dto.description,
  instrumentGroupId: dto.instrumentGroupId,
  instrumentParameters: dto.instrumentParameters
});
